import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { saveAs } from 'file-saver';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import moment from 'moment';

interface ShiftClotsState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;
    meta: any;
    schema: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedFactsList: any[];

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
}

const state: ShiftClotsState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,
    meta: null,
    schema: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedFactsList: [],

    targetForDelete: [],
    // products: [],
    remains: []
};

const initState: any = cloneDeep(state);

const GET_SHIFT_CLOTS_VDP = 'GET_SHIFT_CLOTS_VDP';
const SHIFT_CLOTS_SCHEMA = 'GET_SHIFT_CLOTS_SCHEMA';


export const actions: ActionTree<ShiftClotsState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;
        commit('START_LOADING');

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q(GET_SHIFT_CLOTS_VDP)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'scv.id',
                  datetime: 'scv.datetime',
                  plan_id: 'spv.id',
                  plan_number: 'spv.number',
                  shift_date: 's.shift_date',
                  moment: 'scv.moment',
                  termocamera: 'scv.termocamera',
                  direct_palete: 'scv.direct_palete',
                  direct: 'scv.direct',
                  row_number: 'scv.row_number',
                  base_id: 'b.id',
                  base_name: {$concat: ['b.name', {$: ' '}, 'vst.name']},
                  base_params: {
                    $obj: {
                        upper_ok: 'b.upper_ok',
                        upper_middle: 'b.upper_middle',
                        upper_warn: 'b.upper_warn',
                        lower_ok: 'b.lower_ok',
                        lower_middle: 'b.lower_middle',
                        lower_warn: 'b.lower_warn',
                        upper_getting_warn_dr: 'b.upper_getting_warn_dr',
                        upper_getting_middle_dr: 'b.upper_getting_middle_dr',
                        upper_getting_ok: 'b.upper_getting_ok',
                        upper_getting_middle_k: 'b.upper_getting_middle_k',
                        upper_getting_warn_k: 'b.upper_getting_warn_k',
                        lower_getting_warn_dr: 'b.lower_getting_warn_dr',
                        lower_getting_middle_dr: 'b.lower_getting_middle_dr',
                        lower_getting_ok: 'b.lower_getting_ok',
                        lower_getting_middle_k: 'b.lower_getting_middle_k',
                        lower_getting_warn_k: 'b.lower_getting_warn_k',
                        water_border_ok: 'b.water_border_ok',
                        water_border_ko: 'b.water_border_ko',
                        ph_1h_range: "vst.ph_1h_range",
                        ph_2h_range: "vst.ph_2h_range",
                        ph_3h_range: "vst.ph_3h_range",
                        ph_4h_range: "vst.ph_4h_range",
                        ph_5h_range: "vst.ph_5h_range",
                        ph_6h_range: "vst.ph_6h_range",
                        ph_7h_range: "vst.ph_7h_range",
                        ph_8h_range: "vst.ph_8h_range",
                        ph_9h_range: "vst.ph_9h_range",
                        tooltip_41: "b.tooltip_41",
                        tooltip_42: "b.tooltip_42",
                        tooltip_43: "b.tooltip_43",
                        tooltip_44: "b.tooltip_44",
                        tooltip_71: "b.tooltip_71",
                        tooltip_72: "b.tooltip_72",
                        tooltip_73: "b.tooltip_73",
                        tooltip_74: "b.tooltip_74",
                        temp_low_border_ok: "b.temp_low_border_ok",
                        temp_border_ok: "b.temp_border_ok",
                        temp_high_border_ok: "b.temp_high_border_ok",
                    }
                  },
                  bucket_number: 'scv.bucket_number',
                  temp: 'scv.temp',
                  acidity: 'scv.acidity',
                  elasticity_name: 've.name',
                  causticity_name: 'vc.name',
                  characteristic_name: 'vc3.name',
                  incident_sub_type_name: 'ist.name',
                  incident_type_name: 'it.name',
                  class_value: 'vbc.class_value',
                  letter_value: 'vbc.letter_value',
                  vc_name: 'vc2.name',
                  gas_formation: 'scv.gas_formation',
                  fat_name: 'vf.name',
                  fat_is_warn: 'vf.is_warn',
                  ferment_time: 'sjv.ferment_time',
                  volume_type: 'vv.type',
                },
                from: 's:shift_plan_vdp',
                from_as: 'spv',
                joins: [
                  {
                    join: 's:shifts',
                    type: 'left',
                    as:   's',
                    on: {
                      $eq: ['s.id', 'spv.shift_id']
                    }
                  },
                  {
                    join: 's:shift_clot_vdp',
                    type: 'left',
                    as:   'scv',
                    on: {
                      $eq: ['spv.id', 'scv.plan_id']
                    }
                  },
                  {
                    join: 's:shift_fact_vdp',
                    type: 'left',
                    as:   'sfv',
                    on: {
                      $eq: ['sfv.shift_plan_id', 'spv.id']
                    }
                  },
                  {
                    join: 's:shift_journal_vdp',
                    type: 'left',
                    as:   'sjv',
                    on: {
                      $eq: ['sjv.fact_id', 'sfv.id']
                    }
                  },
                  {
                    join: 's:voc_bases',
                    type: 'left',
                    as:   'b',
                    on: {
                      $eq: ['b.id', 'spv.base_id']
                    }
                  },
                  {
                    join: 's:voc_starter_types',
                    type: 'left',
                    as:   'vst',
                    on: {
                      $eq: ['vst.id', 'spv.starter_type_id']
                    }
                  },
                  {
                    join: 's:voc_elasticities',
                    type: 'left',
                    as:   've',
                    on: {
                      $eq: ['ve.id', 'scv.elasticity_id']
                    }
                  },
                  {
                    join: 's:voc_causticities',
                    type: 'left',
                    as:   'vc',
                    on: {
                      $eq: ['vc.id', 'scv.causticity_id']
                    }
                  },
                  {
                    join: 's:voc_characteristic',
                    type: 'left',
                    as:   'vc3',
                    on: {
                      $eq: ['vc3.id', 'scv.characteristic_id']
                    }
                  },
                  {
                    join: 's:incident_sub_types',
                    type: 'left',
                    as:   'ist',
                    on: {
                      $eq: ['ist.id', 'scv.incident_sub_type_id']
                    }
                  },
                  {
                    join: 's:incident_types',
                    type: 'left',
                    as:   'it',
                    on: {
                      $eq: ['it.id', 'ist.incident_type_id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vc2',
                    on: {
                      $eq: ['vc2.id', 'scv.container_id']
                    }
                  },
                  {
                    join: 's:voc_fat',
                    type: 'left',
                    as:   'vf',
                    on: {
                      $eq: ['vf.id', 'scv.fat_id']
                    }
                  },
                  {
                    join: 's:voc_lines',
                    type: 'left',
                    as:   'vl',
                    on: { 
                      $eq: ['vl.id', 'spv.line_id']
                    }
                  },
                  {
                    join: 's:voc_volumes',
                    type: 'left',
                    as:   'vv',
                    on: {
                      $eq: ['vv.id', 'vl.volume_id']
                    }
                  },
                  {
                    join: 's:view_bases_acidities',
                    type: 'left',
                    as:   'vbc',
                    on: {
                      $and: [
                        { $eq: ['vbc.base_id', 'b.id'] },
                        { $eq: ['vbc.direct', 'scv.direct'] },
                        { $eq: ['vbc.moment', 'scv.moment'] },
                        { $lte: ['vbc.min_value', 'scv.acidity'] },
                        { $gte: ['vbc.max_value', 'scv.acidity'] },
                      ]
                    }
                  },
                ],
                page_size: 1000,
                page: 1,
                order: [
                  {$desc: ['scv.datetime']},
                  {$desc: ['scv.direct']},
                  {$desc: ['scv.id']}
                ],
                where: {
                  $or: [
                    {$eq: [`scv.shift_id`, {$: documentId}]},
                    {$eq: [`spv.shift_id`, {$: documentId}]},
                  ]
                }
              }),
              vm.$q(SHIFT_CLOTS_SCHEMA)
              .raw('schemas.get')
              .action({
                  id: `s:shift_clot_vdp`
              }),
          ]).then((result: ServerResult) => {
            commit('LOADED_SUCCESS');
            const opRelResult = result.getOperation(GET_SHIFT_CLOTS_VDP);
            if (!opRelResult.hasError()) {
              state.relatedFactsList = opRelResult.getContent().documents.map((item: any) => {
                item.delay_time = null;
                if (item.datetime && item.ferment_time) {
                  const _start = moment('1970-01-01 00:00:00').add(moment.duration(moment(item.datetime).diff(moment(item.ferment_time))))
                  console.log('_start', _start.hours())
                  let _hour = _start.hours()
                  if (_start.minutes() > 30) {
                    _hour += 1
                  }
                  item.delay_time = _start.format('HH:mm:ss')
                  switch (_hour) {
                    case 1: 
                      item.ph_h_range = item.base_params.ph_1h_range;
                      break;
                    case 2: 
                      item.ph_h_range = item.base_params.ph_2h_range;
                      break;
                    case 3: 
                      item.ph_h_range = item.base_params.ph_3h_range;
                      break;
                    case 4: 
                      item.ph_h_range = item.base_params.ph_4h_range;
                      break;
                    case 5: 
                      item.ph_h_range = item.base_params.ph_5h_range;
                      break;
                    case 6: 
                      item.ph_h_range = item.base_params.ph_6h_range;
                      break;
                    case 7: 
                      item.ph_h_range = item.base_params.ph_7h_range;
                      break;
                    case 8: 
                      item.ph_h_range = item.base_params.ph_8h_range;
                      break;
                    case 9: 
                      item.ph_h_range = item.base_params.ph_9h_range;
                      break;
                      
                    default: 
                      item.ph_h_range = item.base_params.ph_9h_range;
                      break;
                  }
                  if (item.temp) {
                    const _temp = parseFloat(item.temp)
                    console.log('_temp', _temp)
                    if (_temp < item.base_params.temp_low_border_ok.data[0]) {
                      console.log('1', _temp)
                      item.temp_class = 'is-danger'
                    } else  if (_temp < item.base_params.temp_border_ok.data[0]) {
                      console.log('2', _temp)
                      item.temp_class = 'is-warning'
                    } else  if (_temp < item.base_params.temp_high_border_ok.data[0]) {
                      console.log('3', _temp)
                      item.temp_class = 'is-success'
                    } else  if (_temp < item.base_params.temp_high_border_ok.data[1]) {
                      console.log('4', _temp)
                       item.temp_class = 'is-warning'
                    } else {
                      console.log('5', _temp)
                       item.temp_class = 'is-danger'
                    }
                  }
                  if (_hour >= 4) {
                    let ranges = [];
                    if (_hour >= 7) {
                      ranges = [
                        [item.base_params.tooltip_71 ? item.base_params.tooltip_71.data : [5, 6.5], 'is-success', 'произвести выемку партии'],
                        [item.base_params.tooltip_72 ? item.base_params.tooltip_72.data : [5, 6.5], 'is-info', 'повторно посмотреть pH через час'],
                        [item.base_params.tooltip_73 ? item.base_params.tooltip_73.data : [5, 6.5], 'is-warning', 'повторно посмотреть pH через 2 часа'],
                        [item.base_params.tooltip_74 ? item.base_params.tooltip_74.data : [5, 6.5], 'is-danger', 'повторно посмотреть pH через час'],
                      ]
                    } else {
                      ranges = [
                        [item.base_params.tooltip_41 ? item.base_params.tooltip_41.data : [5, 6.5], 'is-success', 'произвести выемку партии'],
                        [item.base_params.tooltip_42 ? item.base_params.tooltip_42.data : [5, 6.5], 'is-info', 'повторно посмотреть pH через 30 минут'],
                        [item.base_params.tooltip_43 ? item.base_params.tooltip_43.data : [5, 6.5], 'is-warning', 'повторно посмотреть pH через час'],
                        [item.base_params.tooltip_44 ? item.base_params.tooltip_44.data : [5, 6.5], 'is-danger', 'повторно посмотреть pH через 2 часа'],
                      ]
                    }
                    console.log('_hour', _hour)
                    console.log('ranges', ranges)
                    const range = ranges.filter((rn: any) => {
                      return item.acidity >= rn[0][0] && item.acidity <= rn[0][1]
                    })
                    if (range.length) {
                      item.tooltip_class = range[0][1] || 'is-dark'
                      item.tooltip = range[0][2] || '-'
                    } else {
                      item.tooltip = null
                      item.tooltip_class = null
                    }
                  } else {
                    item.tooltip = null
                    item.tooltip_class = null
                  }
                } else {
                  item.ph_h_range = item.base_params.ph_1h_range;
                }
                return item
              })
            }

            const opRelSchema = result.getOperation(SHIFT_CLOTS_SCHEMA);
            if (!opRelSchema.hasError()) {
              state.schema = opRelSchema.getContent().schema
              state.meta = fetchEnumsFromSchema(state.schema)
            }

            resolve(null);
          });
        })
    },

    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>Время измерения</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Момент истины</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Термокамера</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Расположение паллета</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>№ партии</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Наименование базы</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>№ ряда</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>№ ведра</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>t °С</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>рН теплого сгустка</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Степень упругости</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Глубина колкости от поверхности ведра</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Характеристика сгустка, если не колкий</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Уровень качества</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Инцидент</td>
</tr>
{{#clots.documents}}
  <tr height="auto">
    <td wrap border type="date" date-format="DD.MM.YYYY HH:mm">{{datetime}}</td>
    <td wrap border >{{moment}}</td>
    <td wrap border >{{termocamera}}</td>
    <td wrap border >{{direct}}</td>
    <td wrap border >{{plan_number}}</td>
    <td wrap border base>{{base_name}}</td>
    <td wrap border >{{row_number}}</td>
    <td wrap border >{{bucket_number}}</td>
    <td wrap border >{{temp}}</td>
    <td wrap border >{{acidity}}</td>
    <td wrap border >{{elasticity_name}}</td>
    <td wrap border >{{causticity_name}}</td>
    <td wrap border >{{characteristic}}</td>
    <td wrap border >-</td>
    <td wrap border >{{incident_type_name}} / {{incident_sub_type_name}}</td>
  </tr>
{{/clots.documents}}
</table>
                `,
                queries: {
                  clots: {
                    columns: {
                      id: 'scv.id',
                      datetime: 'scv.datetime',
                      plan_number: 'spv.number',
                      shift_date: 's.shift_date',
                      moment: 'scv.moment',
                      termocamera: 'scv.termocamera',
                      direct: 'scv.direct',
                      row_number: 'scv.row_number',
                      base_name: {$concat: ['b.name', {$: ' '}, 'vst.name']},
                      bucket_number: 'scv.bucket_number',
                      temp: 'scv.temp',
                      acidity: 'scv.acidity',
                      elasticity_name: 've.name',
                      causticity_name: 'vc.name',
                      characteristic: 'scv.characteristic',
                      incident_sub_type_name: 'ist.name',
                      incident_type_name: 'it.name',
                    },
                    from: 's:shift_clot_vdp',
                    from_as: 'scv',
                    joins: [
                      {
                        join: 's:shifts',
                        type: 'left',
                        as:   's',
                        on: {
                          $eq: ['s.id', 'scv.shift_id']
                        }
                      },
                      {
                        join: 's:shift_plan_vdp',
                        type: 'left',
                        as:   'spv',
                        on: {
                          $eq: ['spv.id', 'scv.plan_id']
                        }
                      },
                      {
                        join: 's:voc_bases',
                        type: 'left',
                        as:   'b',
                        on: {
                          $eq: ['b.id', 'spv.base_id']
                        }
                      },
                      {
                        join: 's:voc_starter_types',
                        type: 'left',
                        as:   'vst',
                        on: {
                          $eq: ['vst.id', 'spv.starter_type_id']
                        }
                      },
                      {
                        join: 's:voc_elasticities',
                        type: 'left',
                        as:   've',
                        on: {
                          $eq: ['ve.id', 'scv.elasticity_id']
                        }
                      },
                      {
                        join: 's:voc_causticities',
                        type: 'left',
                        as:   'vc',
                        on: {
                          $eq: ['vc.id', 'scv.causticity_id']
                        }
                      },
                      {
                        join: 's:incident_sub_types',
                        type: 'left',
                        as:   'ist',
                        on: {
                          $eq: ['ist.id', 'scv.incident_sub_type_id']
                        }
                      },
                      {
                        join: 's:incident_types',
                        type: 'left',
                        as:   'it',
                        on: {
                          $eq: ['it.id', 'ist.incident_type_id']
                        }
                      },
                    ],
                    order: [
                      {$asc: ['scv.id']}
                    ],
                    where: {
                      $or: [
                        {$eq: [`scv.shift_id`, {$: documentId}]},
                        {$eq: [`scv.shift_id`, {$: documentId}]},
                      ]
                    }
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve();
          }));
      })
    }
};

export const mutations: MutationTree<ShiftClotsState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftClotsState, RootState> = {
  totals : (state: ShiftClotsState) => {
    return {
      sum: state.relatedFactsList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
  finalRelatedFactsList: (state: ShiftClotsState) => {
    return Object.values(state.relatedFactsList.reduce((prev: any, item: any) => {
      if (!prev[item.plan_number] || item.direct == 'up' || prev[item.plan_number].direct == 'down') {
        prev[item.plan_number] = item
      }
      return prev
    }, {}))
  },
  groupByFact: (state: ShiftClotsState) => {
    const names = state.schema.fields.reduce((prev: any, field: any) => {
      prev[field.code] = field.name
      return prev
    }, {})
    const evenDatetime = state.relatedFactsList.reduce((prev: any, item: any) => {
      if (!prev[item.plan_number] ) {
        prev[item.plan_number] = []
      }
      if (!prev[item.plan_number].includes(item.datetime || '-')) {
        prev[item.plan_number].push(item.datetime || '-')
      }
      return prev
    }, {})
    return Object.values(state.relatedFactsList.reduce((prev: any, item: any) => {
      if (!prev[item.plan_number]) {
        prev[item.plan_number] = {
          plan_number: item.plan_number,
          base_name: item.base_name,
          class_row: evenDatetime[item.plan_number].indexOf(item.datetime || '-') % 2 !== 0 ? 'is-even-datetime' : '',
          clots: {
            plan_number: ["№ партии"],
            base_name: ["Наименование базы"],
            datetime: ["Время измерения"],
            ferment_time: ["Время заквашивания"],
            moment: ["Когда замеряли pH"],
            termocamera: [ ( item.volume_type == 'tank' ? "№ танка" :"№ термокамеры")],
            direct: [""],
            direct_palete: ["Этаж с паллетом в термокамере"],
            vc_name: ["Емкость тары, л"],
            row_number: ["№ ряда"],
            bucket_number: ["№ ведра"],
            delay_time: ["Время с момента внесения закваски"],
            temp: ["t °С"],
            acidity: ["рН теплого сгустка"],
            gas_formation: ["Газообразование"],
            elasticity_name: ["Степень упругости"],
            causticity_name: ["Глубина колкости от поверхности ведра"],
            characteristic_name: ["Характеристика сгустка, если не колкий"],
            letter_value: ["Уровень качества"],
            fat_name: ["Отстой жира (на поверхности)"],
            incident_sub_type_name: ["Инцидент"],
            rows: [''],
            class_row: [''],
            tooltip: [''],
            tooltip_class: [''],
          }
        }
      }
      Object.keys(item).map((key: any) => {
        if (!prev[item.plan_number].clots[key]) {
          prev[item.plan_number].clots[key] = [
            ''
          ]
        }
        prev[item.plan_number].clots[key].push(item[key])
      })
      prev[item.plan_number].clots.rows.push(item)
      prev[item.plan_number].clots.class_row.push(evenDatetime[item.plan_number].indexOf(item.datetime) % 2 !== 0 ? 'is-even-datetime' : '')
      return prev
    }, {})).sort((a: any, b: any) => {
      const keyA = parseFloat(a.plan_number);
      const keyB = parseFloat(b.plan_number);
      const result = (keyA > keyB) ? 1 : ((keyA < keyB) ? -1 : 0)
      return result
    })
  }
};

export const STORE_KEY = '$_shift_clots_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
